/* eslint-disable no-restricted-globals */
import { useEffect, useState } from "react";

import Cookie from "js-cookie";

import { FUNCTIONAL_COOKIES } from "~/constants/cookie-categories";
import { DY_USER_ACTIVE_CONSENT } from "~/constants/local-storage";
import { DY_ID_SERVER, OPTANON_ALERT_BOX_CLOSED } from "~/constants/user-cookies";
import { awaitGlobalsInitialization } from "~/helpers/await-globals-initialization";
import { isCookiesGroupAccepted } from "~/helpers/one-trust/cookie-parser";

export const useDyConsent = (): {
  isDyConsentAccepted: boolean;
  isCookieBannerClosed: boolean;
} => {
  const [isDyConsentAccepted, setIsDyConsentAccepted] = useState(() => {
    return typeof localStorage !== "undefined"
      ? localStorage.getItem(DY_USER_ACTIVE_CONSENT) === "true"
      : false;
  });

  useEffect(() => {
    // prettier-ignore
    if (typeof window !== "undefined" && window.DYO?.ActiveConsent) { // NOSONAR
      const accepted = !window.DYO.ActiveConsent.isUserOptOut?.(); // NOSONAR

      setIsDyConsentAccepted(accepted);
    }
  }, []);

  const [isCookieBannerClosed, setIsCookieBannerClosed] = useState<boolean>(() => {
    const optanonAlertBoxClosedCookieValue = Cookie.get(OPTANON_ALERT_BOX_CLOSED);

    return (
      typeof optanonAlertBoxClosedCookieValue === "string" &&
      optanonAlertBoxClosedCookieValue.length > 0
    );
  });

  useEffect(() => {
    if (!isDyConsentAccepted) {
      Cookie.remove(DY_ID_SERVER);
    }
  }, [isDyConsentAccepted]);

  const handleSetDyConsent = () => {
    const isFunctionalCookiesAccepted = isCookiesGroupAccepted(FUNCTIONAL_COOKIES);

    window.DY ??= {};

    window.DY.userActiveConsent = {
      accepted: isFunctionalCookiesAccepted,
    };

    window.DYO?.ActiveConsent?.updateConsentAcceptedStatus(
      isFunctionalCookiesAccepted,
    );

    window.localStorage.setItem(
      DY_USER_ACTIVE_CONSENT,
      String(isFunctionalCookiesAccepted),
    );

    setIsDyConsentAccepted(isFunctionalCookiesAccepted);
    setIsCookieBannerClosed(true);
  };

  useEffect(() => {
    awaitGlobalsInitialization({ windowVar: "OneTrust" }).then(() => {
      window.addEventListener("consent.onetrust", handleSetDyConsent);
    });

    return () => {
      window.removeEventListener("consent.onetrust", handleSetDyConsent);
    };
  }, []);

  return { isDyConsentAccepted, isCookieBannerClosed };
};
/* eslint-enable no-restricted-globals */
